<template>
    <default-layout title="Experience" @open="onOpen">
        <template v-slot:header>
            <Header :title="title" :readonly="true"/>
        </template>
        <template>
            <WizzardVoloHotel ref="wizardRef" :is-experience="true"/>
        </template>
        <template v-slot:sidebar>
            <div>
                <TotalePreventivo class="mb-3"/>
                <Itinerario href="itinerarioRef" @open="onOpen" @service="onDetailService" @hotel="onDetailHotel"/>
            </div>
        </template>
        <template v-slot:footer>
            <div v-if="isMobile" class="menu-footer d-flex justify-content-between">
                <div class="custom-select" @click="onSelectMenu(1)">
                    <h5>Totale: {{totale}} &euro;</h5>
                </div>
                <div class="custom-select" @click="onSelectMenu(2)">
                    <h5>Itinerario</h5>
                </div>
            </div>
            <div v-if="open" class="bottom-menu-popup border-top">
                <div>
                    <div class="d-flex justify-content-end">
                        <div class="close">
                            <img src="../../assets/images/svg/blue/icone_close.svg" height="24px" @click="open = false"/>
                        </div>
                    </div>
                    <div class="content-area">
                        <TotalePreventivo v-if="selected===1" class="mb-3"/>
                        <Itinerario v-if="selected===2" @service="onDetailService" @hotel="onDetailHotel"/>
                    </div>
                </div>
            </div>
        </template>
    </default-layout>
</template>

<script>
import {mapGetters} from 'vuex'
import DefaultLayout from './layout/DefaultLayout'
import Header from '../widgets/pages/experience/layout/Header'
import WizzardVoloHotel from '../widgets/pages/volo-hotel/WizzardVoloHotel'
import TotalePreventivo from '../widgets/common/TotalePreventivo'
import Itinerario from '../widgets/pages/volo-hotel/Itinerario'
import MobileDetector from '../common/MobileDetector'
import {formatMoney} from '../../utils/formatter'

export default {
  name: 'Experience',
  mixins: [MobileDetector],
  components: {Itinerario, TotalePreventivo, WizzardVoloHotel, Header, DefaultLayout},
  computed: {
    experience () {
      return this.getExperienceSelected()
    },
    title () {
      return this.experience.titolo
    },
    totale () {
      return formatMoney(this.summary.totalPrice)
    },
    summary () {
      return this.getSummary()
    }
  },
  data () {
    return {
      selected: 1,
      open: false
    }
  },
  methods: {
    ...mapGetters(['getExperienceSelected', 'getSummary']),
    onOpen (event) {
      this.$refs.wizardRef.openTab(event)
    },
    onSelectMenu (value) {
      this.selected = value
      this.open = true
    },
    onDetailService (item) {
      this.$refs.wizardRef.onShowServiceDetail(item)
    },
    onDetailHotel (item) {
      this.$refs.wizardRef.onShowHotelDetail(item)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/front/components/pages/Experience.vue